import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useThemes } from '../../providers/theme';
import {
  isAdminSession,
  isAuthenticated,
  isImpersonating,
} from '../auth';
import { useMerchant } from '../../store/global/useMerchant';
import { buildMerchantAnalyticsContext, logPageView } from './config';

function AnalyticsTracker() {
  const { pathname } = useLocation();
  const { theme } = useThemes();
  const merchantId = useMerchant((state) => state.data.merchant?.id);
  const merchantName = useMerchant((state) => state.data.merchant?.name?.storeName);
  const merchantState = useMerchant((state) => state.data.merchant?.location?.uf);

  const authenticationStatus = isAuthenticated();
  const adminSession = isAdminSession();
  const impersonating = isImpersonating();
  const requiresMerchant = authenticationStatus && (!adminSession || impersonating);

  const accessMode = impersonating
    ? 'impersonated'
    : adminSession
      ? 'admin'
      : authenticationStatus
        ? 'standard'
        : 'anonymous';

  useEffect(() => {
    if (requiresMerchant && !merchantId) return;

    const merchantAnalyticsData = requiresMerchant
      ? {
          id: merchantId,
          name: { storeName: merchantName },
          location: { uf: merchantState },
        }
      : {};

    const analyticsContext = buildMerchantAnalyticsContext(
      merchantAnalyticsData,
      { theme: requiresMerchant ? theme : null, accessMode }
    );

    logPageView(pathname, analyticsContext);
  }, [
    accessMode,
    merchantId,
    merchantName,
    merchantState,
    pathname,
    requiresMerchant,
    theme,
  ]);

  return null;
}

export default AnalyticsTracker;
